export var PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
export var DEFAULT_PAGE_SIZE = 20;
export var PAGE_SIZE_STORAGE_PREFIX = "pvPageSize.";
export var buildPageSizeStorageKey = function (userId) {
    return "".concat(PAGE_SIZE_STORAGE_PREFIX).concat(userId);
};
export var parsePageSize = function (raw) {
    var parsed = Number(raw);
    return PAGE_SIZE_OPTIONS.includes(parsed) ? parsed : null;
};
